import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/App';
import { I18nProvider } from './i18n/I18nProvider';
import { installGlobalErrorReporting } from './shared/api/errorReporter';

// Must run before '@excalidraw/excalidraw' (lazy-loaded by the Workshops
// Board view) is ever evaluated -- it reads this flag itself while loading
// fonts, and unset it falls back to fetching them from a public esm.sh CDN
// (blocked by our CSP, and not something an internal Visma tool should
// depend on regardless). Setting it inside the Board module itself turned
// out to be too late in practice -- excalidraw's own internal chunking
// raced it -- so this sits in the one place guaranteed to run before any
// lazy route chunk does: the app's actual entry bundle. craco.config.js
// copies the real font files into the build at this same path.
(window as any).EXCALIDRAW_ASSET_PATH = '/excalidraw-assets/';

installGlobalErrorReporting();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </React.StrictMode>
);
